import React, { Fragment, Suspense } from "react";

import Preloader from "../Components/common/Preloader";

const Banner = React.lazy(() => import("../Components/Banner"));
const About = React.lazy(() => import("../Components/About"));
const Blog = React.lazy(() => import("../Components/Blog"));
const Contact = React.lazy(() => import("../Components/Contact"));
const Counter = React.lazy(() => import("../Components/Counter"));
const Feature = React.lazy(() => import("../Components/Feature"));

const Customers = React.lazy(() => import("../Components/Customers"));
const Notices = React.lazy(() => import("../Components/Notices"));
const Service = React.lazy(() => import("../Components/Service"));
const Team = React.lazy(() => import("../Components/Team"));
const Testimonial = React.lazy(() => import("../Components/Testimonial"));
const WhyChooseUs = React.lazy(() => import("../Components/WhyChooseUs"));
const SearchPopup = React.lazy(() => import("../Components/common/SearchPopup"));

const Home = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        {/* Search Popup */}
        <SearchPopup />

        {/* Navbar  */}
        {/* <Navbar /> */}

        {/* Banner  */}
        <Banner />

        {/* Feature  */}
        <Feature />

        {/* About  */}
        <About />

        {/* Service  */}
        <Service />

        {/* Why Choose Us  */}
        <WhyChooseUs />

        {/* Counter  */}

        <Counter />

        {/* Team  */}
        <Team />

        {/* Contact  */}
        <div
          className="call-to-contact-area pd-top-240"
          style={{ background: "#F9F9F9" }}
        >
          <Contact />
        </div>

        {/* Testimonial  */}
        {/* <Testimonial /> */}

        <div className="pd-top-115 pd-bottom-120"></div>

        {/* Notices  */}
        <Notices />

        {/* Blog  */}
        {/* <Blog /> */}

        {/* Customers  */}
        <Customers />
      </Suspense>
    </Fragment>
  );
};

export default Home;
